module.exports = __webpack_public_path__ + "img/help-user2.2d68d98b.png";